import React, { useEffect, useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import Subtitle2 from "../Text/Subtitle2";
import { VisitorsService } from "deliziora-client-module/client-web";
import { Flex } from "antd";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// export const options = {
//     responsive: true,
//     plugins: {
//         legend: {
//             position: 'top',
//         },
//         title: {
//             display: true,
//             text: 'Visitantes por mês',
//         },
//     },
// };

const labels = [
  "Jan",
  "Fev",
  "Mar",
  "Abr",
  "Mai",
  "Jun",
  "Jul",
  "Ago",
  "Set",
  "Nov",
  "Dez",
];

const colors = require("../../styles/Colors.json");

export function ChartHomeRestaurantVisitors() {
  const [lastedUpdated, setLastedUpdated] = React.useState(
    new Date().toLocaleString()
  );
  const [visitors, setVisitors] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userData"));
  function getAbbreviatedMonth(timestamp) {
    const monthsAbbreviated = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const date = new Date(timestamp);
    return monthsAbbreviated[date.getMonth()];
  }

  const data = {
    labels,
    datasets: [
      {
        label: "Visitantes",
        data: visitors,
        backgroundColor: colors.colors.baseColor.base_01,
      },
    ],
  };

  useEffect(() => {
    setInterval(() => {
      console.log("Atualizando");
      setLastedUpdated(new Date().toLocaleString());
    }, 10000);
  }, []);
  useEffect(() => {
    console.log(userData._id.$oid) 
    VisitorsService.getAllVisitorsByRestaurant(userData._id.$oid).then((res) => {
      console.log(res.data);

      // Object to store counts for each month
      const monthlyCounts = {
        Jan: 0,
        Feb: 0,
        Mar: 0,
        Apr: 0,
        May: 0,
        Jun: 0,
        Jul: 0,
        Aug: 0,
        Sep: 0,
        Oct: 0,
        Nov: 0,
        Dec: 0,
      };

      // Create a set to store unique users for each month
      const uniqueUsersByMonth = {
        Jan: new Set(),
        Feb: new Set(),
        Mar: new Set(),
        Apr: new Set(),
        May: new Set(),
        Jun: new Set(),
        Jul: new Set(),
        Aug: new Set(),
        Sep: new Set(),
        Oct: new Set(),
        Nov: new Set(),
        Dec: new Set(),
      };

      // Iterate through the data and update counts
      res.data.forEach((entry) => {
        const timestamp = entry.created_at.$date;
        const month = getAbbreviatedMonth(timestamp);
        const userId = entry.id_user;

        if (!uniqueUsersByMonth[month].has(userId)) {
          uniqueUsersByMonth[month].add(userId);
          monthlyCounts[month] += 1; // Increment count for the month
        }
      });

      // Create the array ordered by month
      const orderedArray = Object.values(monthlyCounts);

      console.log(orderedArray);
      setVisitors(orderedArray);
    });
  }, []);
  useEffect(() => {
    setInterval(() => {
      console.log("Atualizando");
      setLastedUpdated(new Date().toLocaleString());
    }, 10000);
  }, []);
  return (
    <Flex
      vertical
      style={{
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Bar
        options={{
          bar: {
            datasets: {
              label: "Oscaer",
            },
          },
          layout: {},
        }}
        data={data}
      />
      <div
        style={{ justifyContent: "center", display: "flex", marginTop: "1rem" }}
      >
        <Subtitle2 text={"Última atualização: " + lastedUpdated} />
      </div>
    </Flex>
  );
}
